import { defineStyle } from '@chakra-ui/react';

import colors from '@/styles/themes/brand/colors';
import FontSizes from '@/styles/themes/brand/fontSizes';
import FontWeights from '@/styles/themes/brand/fontWeights';

const style = defineStyle({
  root: {
    mt: '32px',
    // mb: '20px',
  },
  title: { color: colors.primary, fontWeight: FontWeights.bold },
  mainContainer: { mt: '32px' },
  linkContainer: {
    flex: 1,
    w: '100%',
    position: 'relative',
    cursor: 'pointer',
    gap: 0,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'row',
    textDecoration: 'none',
    _hover: {
      textDecoration: 'none',
    },
  },
  stepContainer: { gap: '12px', pb: '30px' },
  dlpContainer: {
    background: ' #DDDDDD66',
    borderRadius: '16px',
    padding: '13px',
  },
  dlpIcon: {
    height: '48px',
    width: '45px',
  },
  dlpTextContainer: { flexDir: 'column', gap: '10px' },
  dlpText: {
    fontsize: FontSizes.normal,
    flex: 1,
    w: '100%',
    _ltr: {
      ml: '5px',
    },
    _rtl: {
      mr: '10px',
    },
  },
  dlpNews: {
    borderRadius: '100px',
    background: '#BE9D4733',
    padding: '4px 8px',
    width: 'max-content',
    fontSize: '12px',
    fontWeight: '600',
    color: '#C09E47',
    _ltr: {
      ml: '5px',
    },
    _rtl: {
      mr: '10px',
    },
  },
  existingIcons: {
    background: 'white',
    position: 'absolute',
    width: 30,
    height: 30,
    _ltr: {
      left: '0',
    },
    _rtl: {
      right: '0',
    },
    top: '-2',
    borderRadius: '50%',
    zIndex: 1,
  },
  existingTexts: {
    fontsize: FontSizes.normal,
    flex: 1,
    w: '100%',
    pb: '30px',
  },
  dlpHighLightIcon: {
    height: '32px',
    width: '133px',
    position: 'absolute',
  },
  dlpTexts: {
    color: '#000',
    fontSize: FontSizes.xSmall,
    fontWeight: FontWeights.normal,
    _ltr: {
      padding: '8px 0px 0px 12px',
    },
    _rtl: {
      padding: '8px 10px 0px 0px',
    },
    position: 'absolute',
  },
  stepIcon: { height: '15px', width: '16px', color: colors.backgroundBlack },
  stepCompletedIcon: { height: '24px', width: '24px' },
});

export default style;

// import { defineStyle } from '@chakra-ui/react';

// import colors from '@/styles/themes/brand/colors';
// import FontSizes from '@/styles/themes/brand/fontSizes';
// import FontWeights from '@/styles/themes/brand/fontWeights';

// const style = defineStyle({
//   root: {
//     mt: '32px',
//     mb: '20px',
//   },
//   title: { color: colors.primary, fontWeight: FontWeights.bold },
//   mainContainer: { mt: '32px' },
//   linkContainer: {
//     flex: 1,
//     w: '100%',
//     position: 'relative',
//     cursor: 'pointer',
//     gap: 0,
//     justifyContent: 'flex-start',
//     alignItems: 'flex-start',
//     flexDirection: 'row',
//     textDecoration: 'none',
//     _hover: {
//       textDecoration: 'none',
//     },
//   },
//   stepContainer: { gap: '12px', pb: '30px' },
//   dlpContainer: {
//     background: ' #DDDDDD66',
//     borderRadius: '16px',
//     padding: '13px',
//   },
//   dlpIcon: {
//     height: '48px',
//     width: '45px',
//   },
//   dlpTextContainer: { flexDir: 'column', gap: '10px' },
//   dlpText: {
//     fontsize: FontSizes.normal,
//     flex: 1,
//     w: '100%',
//     _ltr: {
//       ml: '5px',
//     },
//     _rtl: {
//       mr: '10px',
//     },
//   },
//   dlpNews: {
//     borderRadius: '100px',
//     background: '#BE9D4733',
//     padding: '4px 8px',
//     width: 'max-content',
//     fontSize: '12px',
//     fontWeight: '600',
//     color: '#C09E47',
//     _ltr: {
//       ml: '5px',
//     },
//     _rtl: {
//       mr: '10px',
//     },
//   },
//   existingIcons: {
//     background: 'white',
//     position: 'absolute',
//     width: 30,
//     height: 30,
//     _ltr: {
//       left: '0',
//     },
//     _rtl: {
//       right: '0',
//     },
//     top: '-2',
//     borderRadius: '50%',
//     zIndex: 1,
//   },
//   existingTexts: {
//     fontsize: FontSizes.normal,
//     flex: 1,
//     w: '100%',
//     pb: '30px',
//   },
//   dlpHighLightIcon: {
//     height: '32px',
//     width: '133px',
//     position: 'absolute',
//   },
//   dlpTexts: {
//     color: '#000',
//     fontSize: FontSizes.xSmall,
//     fontWeight: FontWeights.normal,
//     _ltr: {
//       padding: '8px 0px 0px 12px',
//     },
//     _rtl: {
//       padding: '8px 10px 0px 0px',
//     },
//     position: 'absolute',
//   },
//   stepIcon: { height: '15px', width: '16px' },
//   stepCompletedIcon: { height: '24px', width: '24px' },
// });

// export default style;
